import { render, staticRenderFns } from "./Maxw.vue?vue&type=template&id=e90e51b4&scoped=true&"
import script from "./Maxw.vue?vue&type=script&lang=js&"
export * from "./Maxw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90e51b4",
  null
  
)

export default component.exports